import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-copy",
  "use": "icon-copy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-copy\"><path fill=\"currentColor\" d=\"M659.2 67.648a64 64 0 0 1 64 64V302.08h167.936a64 64 0 0 1 64 64v526.272a64 64 0 0 1-64 64H364.8a64 64 0 0 1-64-64V721.92H132.8a64 64 0 0 1-64-64V131.648a64 64 0 0 1 64-64H659.2z m104.384 361.92h-40.448l0.064 228.352a64 64 0 0 1-64 64H428.288v42.88a64 64 0 0 0 56.576 63.616l7.488 0.448h271.232a64 64 0 0 0 63.552-56.576l0.448-7.424V493.568a64 64 0 0 0-56.512-63.552l-7.488-0.448z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol